unit form.APIProcessStatus;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter, Vcl.Controls,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, WEBLib.ExtCtrls,
  System.Types, System.DateUtils, System.Generics.Collections;

type
  TfrmAPIProcessStatus = class(TForm)
    wcStatus: TXDataWebClient;
    wdsStatus: TXDataWebDataSet;
    dsStatus: TDataSource;
    wdsStatusAccountNo: TIntegerField;
    wdsStatusAccountName: TStringField;
    wdsStatusSuspended: TBooleanField;
    wdsStatusProcessserver: TIntegerField;
    wdsStatusDostfmsprocesswb: TBooleanField;
    wdsStatusLastwashbayprocess: TDateTimeField;
    wdsStatusDostfmsprocess: TBooleanField;
    wdsStatusLaststfmsdieselprocess: TDateTimeField;
    wdsStatusDofmsprocess: TBooleanField;
    wdsStatusLastfmsdieselprocess: TDateTimeField;
    wdsStatusDotfnprocess: TBooleanField;
    wdsStatusLasttfndieselprocess: TDateTimeField;
    wdsStatusDoxfuelsprocess: TBooleanField;
    wdsStatusLastxfuelsdieselprocess: TDateTimeField;
    wdsStatusDofueluprocess: TBooleanField;
    wdsStatusLastfueludieselprocess: TDateTimeField;
    WebTimer1: TTimer;
    gStatus: TTMSFNCDataGrid;
    gdaStatus: TTMSFNCDataGridDatabaseAdapter;
    procedure WebFormShow(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);
    procedure wdsStatusAfterOpen(DataSet: TDataSet);
    procedure gStatusAfterDrawCell(Sender: TObject; AGraphics: TTMSFNCGraphics;
      ACell: TTMSFNCDataGridCell);
  private
    { Private declarations }
    procedure LoadData;
    procedure GroupStatus;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmAPIProcessStatus: TfrmAPIProcessStatus;

implementation

{$R *.dfm}

Uses
  db.Connection;

procedure TfrmAPIProcessStatus.GroupStatus;
  var
    l : TList<Integer>;
    c : TTMSFNCDataGridDataGetCustomGroupCallBack;
begin
  l := TList<Integer>.Create;

  l.Add(0);

  gStatus.Group(CreateGroupInfo(l.ToArray), c);

  l.free;

  gStatus.CollapseAllNodes;
end;

procedure TfrmAPIProcessStatus.gStatusAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    dtValue : TDateTime;
    bCheck : Boolean;
begin
  If (ACell.Column = 5) and (ACell.Row > 0) then
    begin


      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          AGraphics.Stroke.Color := gcBlack;
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end
      else
        AGraphics.Stroke.Color := gcWhite;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 7) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 9) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 11) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 13) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
  If (ACell.Column = 15) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      bCheck := gStatus.Booleans[ACell.Column - 1,ACell.Row];
      dtValue := gStatus.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 145 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      if bCheck then
        begin
          If (MinutesBetween(Now, dtValue) > 15) and (MinutesBetween(Now, dtValue) < 30) then
            begin
              AGraphics.Fill.Color := gcYellow;
              AGraphics.Font.Color := gcBlack;
            end
          else
            If (MinutesBetween(Now, dtValue) > 30) then
              begin
                AGraphics.Fill.Color := gcRed;
                AGraphics.Font.Color := gcWhite;
              end
            else
              begin
                AGraphics.Fill.Color := gcLime;
                AGraphics.Font.Color := gcBlack;
              end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      if dtValue > 0 then
        AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy HH:mm:ss', dtValue), False, gtaCenter, gtaCenter)
      else
        AGraphics.DrawText(r, '', False, gtaCenter, gtaCenter);
    end;
end;

procedure TfrmAPIProcessStatus.LoadData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadData;
      end
    else
      begin
        wdsStatus.Close;
        wdsStatus.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsStatus.Open;
      end;
  end;

begin
  wcStatus.RawInvoke('IstsupportService.GetAPIProcessStatus', [], @OnResult, @OnError);
end;

procedure TfrmAPIProcessStatus.wdsStatusAfterOpen(DataSet: TDataSet);
begin
  //GroupStatus;
  WebTimer1.Enabled := True;
end;

procedure TfrmAPIProcessStatus.WebFormShow(Sender: TObject);
begin
  LoadData;
end;

procedure TfrmAPIProcessStatus.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  LoadData;
end;

procedure TfrmAPIProcessStatus.LoadDFMValues;
begin
  inherited LoadDFMValues;

  gStatus := TTMSFNCDataGrid.Create(Self);
  gdaStatus := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcStatus := TXDataWebClient.Create(Self);
  wdsStatus := TXDataWebDataSet.Create(Self);
  wdsStatusAccountNo := TIntegerField.Create(Self);
  wdsStatusAccountName := TStringField.Create(Self);
  wdsStatusSuspended := TBooleanField.Create(Self);
  wdsStatusProcessserver := TIntegerField.Create(Self);
  wdsStatusDostfmsprocesswb := TBooleanField.Create(Self);
  wdsStatusLastwashbayprocess := TDateTimeField.Create(Self);
  wdsStatusDostfmsprocess := TBooleanField.Create(Self);
  wdsStatusLaststfmsdieselprocess := TDateTimeField.Create(Self);
  wdsStatusDofmsprocess := TBooleanField.Create(Self);
  wdsStatusLastfmsdieselprocess := TDateTimeField.Create(Self);
  wdsStatusDotfnprocess := TBooleanField.Create(Self);
  wdsStatusLasttfndieselprocess := TDateTimeField.Create(Self);
  wdsStatusDoxfuelsprocess := TBooleanField.Create(Self);
  wdsStatusLastxfuelsdieselprocess := TDateTimeField.Create(Self);
  wdsStatusDofueluprocess := TBooleanField.Create(Self);
  wdsStatusLastfueludieselprocess := TDateTimeField.Create(Self);
  dsStatus := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);

  gStatus.BeforeLoadDFMValues;
  gdaStatus.BeforeLoadDFMValues;
  wcStatus.BeforeLoadDFMValues;
  wdsStatus.BeforeLoadDFMValues;
  wdsStatusAccountNo.BeforeLoadDFMValues;
  wdsStatusAccountName.BeforeLoadDFMValues;
  wdsStatusSuspended.BeforeLoadDFMValues;
  wdsStatusProcessserver.BeforeLoadDFMValues;
  wdsStatusDostfmsprocesswb.BeforeLoadDFMValues;
  wdsStatusLastwashbayprocess.BeforeLoadDFMValues;
  wdsStatusDostfmsprocess.BeforeLoadDFMValues;
  wdsStatusLaststfmsdieselprocess.BeforeLoadDFMValues;
  wdsStatusDofmsprocess.BeforeLoadDFMValues;
  wdsStatusLastfmsdieselprocess.BeforeLoadDFMValues;
  wdsStatusDotfnprocess.BeforeLoadDFMValues;
  wdsStatusLasttfndieselprocess.BeforeLoadDFMValues;
  wdsStatusDoxfuelsprocess.BeforeLoadDFMValues;
  wdsStatusLastxfuelsdieselprocess.BeforeLoadDFMValues;
  wdsStatusDofueluprocess.BeforeLoadDFMValues;
  wdsStatusLastfueludieselprocess.BeforeLoadDFMValues;
  dsStatus.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  try
    Name := 'frmAPIProcessStatus';
    Width := 1122;
    Height := 480;
    Align := alClient;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    gStatus.SetParentComponent(Self);
    gStatus.Name := 'gStatus';
    gStatus.Left := 0;
    gStatus.Top := 0;
    gStatus.Width := 1122;
    gStatus.Height := 480;
    gStatus.Align := alClient;
    gStatus.ParentDoubleBuffered := False;
    gStatus.DoubleBuffered := True;
    gStatus.TabOrder := 0;
    gStatus.ShowAcceleratorChar := False;
    gStatus.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gStatus.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gStatus.Header.VisualGrouping.Layout.Font.Height := -12;
    gStatus.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gStatus.Header.VisualGrouping.Layout.Font.Style := [];
    gStatus.Adapter := gdaStatus;
    gStatus.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gStatus.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.FilterMatchLayout.Font.Style := [];
    gStatus.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gStatus.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gStatus.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.BandLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.BandLayout.Font.Height := -12;
    gStatus.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.BandLayout.Font.Style := [];
    gStatus.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.FixedLayout.Font.Height := -12;
    gStatus.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.FixedLayout.Font.Style := [];
    gStatus.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gStatus.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gStatus.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.FocusedLayout.Font.Height := -12;
    gStatus.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.FocusedLayout.Font.Style := [];
    gStatus.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.GroupLayout.Font.Height := -12;
    gStatus.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.GroupLayout.Font.Style := [];
    gStatus.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.NormalLayout.Font.Height := -12;
    gStatus.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.NormalLayout.Font.Style := [];
    gStatus.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.SelectedLayout.Font.Height := -12;
    gStatus.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.SelectedLayout.Font.Style := [];
    gStatus.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gStatus.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gStatus.CellAppearance.SummaryLayout.Font.Height := -12;
    gStatus.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gStatus.CellAppearance.SummaryLayout.Font.Style := [];
    gStatus.ColumnCount := 16;
    gStatus.Columns.Clear;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Process';
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'No';
      Width := 50.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Client';
      Width := 250.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Active';
      Width := 50.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Dostfmsprocess';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STFMS Diesel';
      Width := 150.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Dofmsprocess';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'FMS Diesel';
      Width := 150.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Dotfnprocess';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TFN Diesel';
      Width := 150.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Doxfuelsprocess';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'XFuels Diesel';
      Width := 150.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Dofueluprocess';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'FuelU Diesel';
      Width := 150.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Dostfmsprocesswb';
      Width := 20.000000000000000000;
    end;
    with gStatus.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Washbay';
      Width := 150.000000000000000000;
    end;
    gStatus.Designer := False;
    gStatus.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gStatus.FilterAppearance.Font.Color := clWindowText;
    gStatus.FilterAppearance.Font.Height := -12;
    gStatus.FilterAppearance.Font.Name := 'Segoe UI';
    gStatus.FilterAppearance.Font.Style := [];
    gStatus.Icons.ExpandIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.ExpandIcon.svg');
    gStatus.Icons.CollapseIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.CollapseIcon.svg');
    gStatus.Icons.FilterIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.FilterIcon.svg');
    gStatus.Icons.FilterActiveIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.FilterActiveIcon.svg');
    gStatus.Icons.FilterClearIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.FilterClearIcon.svg');
    gStatus.Icons.FilterTypeIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.FilterTypeIcon.svg');
    gStatus.Icons.SortAscendingIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.SortAscendingIcon.svg');
    gStatus.Icons.SortDescendingIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.SortDescendingIcon.svg');
    gStatus.Icons.CloseIcon.LoadFromFile('form.APIProcessStatus.gStatus.Icons.CloseIcon.svg');
    SetEvent(gStatus, Self, 'OnAfterDrawCell', 'gStatusAfterDrawCell');
    gStatus.Options.Sorting.Enabled := True;
    gStatus.Options.Editing.Enabled := False;
    gStatus.RowCount := 1;
    gdaStatus.SetParentComponent(gStatus);
    gdaStatus.Name := 'gdaStatus';
    gdaStatus.Left := 584;
    gdaStatus.Top := 200;
    gdaStatus.Width := 26;
    gdaStatus.Height := 26;
    gdaStatus.Visible := True;
    gdaStatus.AutoCreateColumns := False;
    gdaStatus.AutoRemoveColumns := False;
    gdaStatus.Columns.Clear;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Processserver';
      Header := 'Process';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'AccountNo';
      Header := 'No';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'AccountName';
      Header := 'Client';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Suspended';
      Header := 'Active';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Dostfmsprocess';
      Header := 'Dostfmsprocess';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lastfmsdieselprocess';
      Header := 'STFMS Diesel';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Dofmsprocess';
      Header := 'Dofmsprocess';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lastfmsdieselprocess';
      Header := 'FMS Diesel';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Dotfnprocess';
      Header := 'Dotfnprocess';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lasttfndieselprocess';
      Header := 'TFN Diesel';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Doxfuelsprocess';
      Header := 'Doxfuelsprocess';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lastxfuelsdieselprocess';
      Header := 'XFuels Diesel';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Dofueluprocess';
      Header := 'Dofueluprocess';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lastfueludieselprocess';
      Header := 'FuelU Diesel';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Dostfmsprocesswb';
      Header := 'Dostfmsprocesswb';
      AutoCreated := False;
    end;
    with gdaStatus.Columns.Add do
    begin
      FieldName := 'Lastwashbayprocess';
      Header := 'Washbay';
      AutoCreated := False;
    end;
    gdaStatus.DataSource := dsStatus;
    gdaStatus.LoadMode := almAllRecords;
    wcStatus.SetParentComponent(Self);
    wcStatus.Name := 'wcStatus';
    wcStatus.Connection := dmData.dbConnect;
    wcStatus.Left := 160;
    wcStatus.Top := 152;
    wdsStatus.SetParentComponent(Self);
    wdsStatus.Name := 'wdsStatus';
    wdsStatus.AfterOpen := wdsStatusAfterOpen;
    wdsStatus.Connection := dmData.dbConnect;
    wdsStatus.Left := 232;
    wdsStatus.Top := 240;
    wdsStatusAccountNo.SetParentComponent(wdsStatus);
    wdsStatusAccountNo.Name := 'wdsStatusAccountNo';
    wdsStatusAccountNo.FieldName := 'AccountNo';
    wdsStatusAccountName.SetParentComponent(wdsStatus);
    wdsStatusAccountName.Name := 'wdsStatusAccountName';
    wdsStatusAccountName.FieldName := 'AccountName';
    wdsStatusSuspended.SetParentComponent(wdsStatus);
    wdsStatusSuspended.Name := 'wdsStatusSuspended';
    wdsStatusSuspended.FieldName := 'Suspended';
    wdsStatusProcessserver.SetParentComponent(wdsStatus);
    wdsStatusProcessserver.Name := 'wdsStatusProcessserver';
    wdsStatusProcessserver.FieldName := 'Processserver';
    wdsStatusDostfmsprocesswb.SetParentComponent(wdsStatus);
    wdsStatusDostfmsprocesswb.Name := 'wdsStatusDostfmsprocesswb';
    wdsStatusDostfmsprocesswb.FieldName := 'Dostfmsprocesswb';
    wdsStatusLastwashbayprocess.SetParentComponent(wdsStatus);
    wdsStatusLastwashbayprocess.Name := 'wdsStatusLastwashbayprocess';
    wdsStatusLastwashbayprocess.FieldName := 'Lastwashbayprocess';
    wdsStatusDostfmsprocess.SetParentComponent(wdsStatus);
    wdsStatusDostfmsprocess.Name := 'wdsStatusDostfmsprocess';
    wdsStatusDostfmsprocess.FieldName := 'Dostfmsprocess';
    wdsStatusLaststfmsdieselprocess.SetParentComponent(wdsStatus);
    wdsStatusLaststfmsdieselprocess.Name := 'wdsStatusLaststfmsdieselprocess';
    wdsStatusLaststfmsdieselprocess.FieldName := 'Laststfmsdieselprocess';
    wdsStatusDofmsprocess.SetParentComponent(wdsStatus);
    wdsStatusDofmsprocess.Name := 'wdsStatusDofmsprocess';
    wdsStatusDofmsprocess.FieldName := 'Dofmsprocess';
    wdsStatusLastfmsdieselprocess.SetParentComponent(wdsStatus);
    wdsStatusLastfmsdieselprocess.Name := 'wdsStatusLastfmsdieselprocess';
    wdsStatusLastfmsdieselprocess.FieldName := 'Lastfmsdieselprocess';
    wdsStatusDotfnprocess.SetParentComponent(wdsStatus);
    wdsStatusDotfnprocess.Name := 'wdsStatusDotfnprocess';
    wdsStatusDotfnprocess.FieldName := 'Dotfnprocess';
    wdsStatusLasttfndieselprocess.SetParentComponent(wdsStatus);
    wdsStatusLasttfndieselprocess.Name := 'wdsStatusLasttfndieselprocess';
    wdsStatusLasttfndieselprocess.FieldName := 'Lasttfndieselprocess';
    wdsStatusDoxfuelsprocess.SetParentComponent(wdsStatus);
    wdsStatusDoxfuelsprocess.Name := 'wdsStatusDoxfuelsprocess';
    wdsStatusDoxfuelsprocess.FieldName := 'Doxfuelsprocess';
    wdsStatusLastxfuelsdieselprocess.SetParentComponent(wdsStatus);
    wdsStatusLastxfuelsdieselprocess.Name := 'wdsStatusLastxfuelsdieselprocess';
    wdsStatusLastxfuelsdieselprocess.FieldName := 'Lastxfuelsdieselprocess';
    wdsStatusDofueluprocess.SetParentComponent(wdsStatus);
    wdsStatusDofueluprocess.Name := 'wdsStatusDofueluprocess';
    wdsStatusDofueluprocess.FieldName := 'Dofueluprocess';
    wdsStatusLastfueludieselprocess.SetParentComponent(wdsStatus);
    wdsStatusLastfueludieselprocess.Name := 'wdsStatusLastfueludieselprocess';
    wdsStatusLastfueludieselprocess.FieldName := 'Lastfueludieselprocess';
    dsStatus.SetParentComponent(Self);
    dsStatus.Name := 'dsStatus';
    dsStatus.AutoEdit := False;
    dsStatus.DataSet := wdsStatus;
    dsStatus.Left := 368;
    dsStatus.Top := 224;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    WebTimer1.Interval := 300000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 528;
    WebTimer1.Top := 256;
  finally
    gStatus.AfterLoadDFMValues;
    gdaStatus.AfterLoadDFMValues;
    wcStatus.AfterLoadDFMValues;
    wdsStatus.AfterLoadDFMValues;
    wdsStatusAccountNo.AfterLoadDFMValues;
    wdsStatusAccountName.AfterLoadDFMValues;
    wdsStatusSuspended.AfterLoadDFMValues;
    wdsStatusProcessserver.AfterLoadDFMValues;
    wdsStatusDostfmsprocesswb.AfterLoadDFMValues;
    wdsStatusLastwashbayprocess.AfterLoadDFMValues;
    wdsStatusDostfmsprocess.AfterLoadDFMValues;
    wdsStatusLaststfmsdieselprocess.AfterLoadDFMValues;
    wdsStatusDofmsprocess.AfterLoadDFMValues;
    wdsStatusLastfmsdieselprocess.AfterLoadDFMValues;
    wdsStatusDotfnprocess.AfterLoadDFMValues;
    wdsStatusLasttfndieselprocess.AfterLoadDFMValues;
    wdsStatusDoxfuelsprocess.AfterLoadDFMValues;
    wdsStatusLastxfuelsdieselprocess.AfterLoadDFMValues;
    wdsStatusDofueluprocess.AfterLoadDFMValues;
    wdsStatusLastfueludieselprocess.AfterLoadDFMValues;
    dsStatus.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
  end;
end;

end.